import React from 'react';
import { Star, Award } from 'lucide-react';
export function TopBanner() {
  return <div className="bg-[#001A44] text-white py-2 px-4 md:px-6 border-b border-blue-900/50 relative z-40" data-id="element-147">
      <div className="container mx-auto flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-8 text-xs md:text-sm font-medium" data-id="element-148">
        <div className="flex items-center gap-2" aria-label="NEMT Certified Business" data-id="element-149">
          <Award size={16} className="text-blue-400" aria-hidden="true" data-id="element-150" />
          <span data-id="element-151">NEMT Certified Business</span>
        </div>
        <div className="hidden sm:block w-px h-4 bg-blue-800" aria-hidden="true" data-id="element-152" />
        <div className="flex items-center gap-2" aria-label="5 Star Google Review" data-id="element-153">
          <div className="flex items-center gap-0.5" data-id="element-154">
            {[...Array(5)].map((_, i) => <Star key={i} size={14} className="fill-yellow-400 text-yellow-400" aria-hidden="true" data-id="element-155" />)}
          </div>
          <span data-id="element-156">5-Star Google Review Rating</span>
        </div>
      </div>
    </div>;
}